var render = function render(){var _vm=this,_c=_vm._self._c;return _c('slice',{staticClass:"slice--simple-content container",class:{
    'slice--right-img': _vm.block.image_position === 'right',
    'image-in-screen': _vm.imageInScreen,
    'slice--no-gap': !_vm.block.gap,
  },attrs:{"id":_vm.block._key},on:{"in":function($event){return _vm.$emit('in')},"out":function($event){return _vm.$emit('out')}}},[_c('div',{staticClass:"row-md row-hard align-center",class:{
      'justify-end':
        _vm.block.image_position === 'right' &&
        _vm.block.image_format === _vm.IMAGE_FORMAT.PORTRAIT,
    }},[_c('div',{directives:[{name:"waypoint",rawName:"v-waypoint",value:({
        active: true,
        callback: _vm.onWaypoint,
        options: _vm.intersectionOptions,
      }),expression:"{\n        active: true,\n        callback: onWaypoint,\n        options: intersectionOptions,\n      }"}],staticClass:"col-md-6 slice__img mb-2 mb-md-0",class:`slice__img--${_vm.block.image_format}`,style:(_vm.hasImageBackgroundColor
          ? {
              background: _vm.block.image_background_color,
            }
          : '')},[(_vm.image && _vm.image.url)?_c('lazy-image',{staticClass:"flex-grow-1",attrs:{"image":_vm.image,"sizes":_vm.sizes,"widths":_vm.widths,"provider":"sanity"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"d-md-flex align-center slice__text",class:_vm.blockTextClass},[_c('div',{staticClass:"block-text",class:{ 'pt-md-2 pb-md-2': _vm.hasImageBackgroundColor }},[_c('portable-text',{staticClass:"block-text__text",attrs:{"blocks":_vm.block.text}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }